import { AttributeEntityType } from 'src/app/shared/models/attributes/attributeEntityType';
export class CustomViewColumn implements ICustomViewColumn {
  public systemName: string;
  public displayName: string;
  public customFieldId: string = null;
  public rank: number;
  public customFieldEntityType: AttributeEntityType = null;
  public isCustomField: boolean = false;
  public isComplexCustomField: boolean = false;
  public isCalculatedField: boolean = false;

  public static createSystemColumn(
    systemName: string,
    displayName: string,
    rank: number
  ): CustomViewColumn {
    let customViewColumn = new CustomViewColumn();
    customViewColumn.systemName = systemName;
    customViewColumn.displayName = displayName;
    customViewColumn.rank = rank;
    return customViewColumn;
  }

  public static parse(data: ICustomViewColumn): CustomViewColumn {
    let customViewColumn = new CustomViewColumn();
    Object.assign(customViewColumn, data);

    return customViewColumn;
  }

  public get columnDefinition() {
    return this.isCustomField ? this.customFieldId : this.systemName;
  }
}
export interface ICustomViewColumn {
  systemName: string;
  displayName: string;
  customFieldId: string;
  rank: number;
  customFieldEntityType: AttributeEntityType;
  isCustomField: boolean;
  isComplexCustomField: boolean;
  isCalculatedField: boolean;
}
